import { useMemo } from 'react'
import {
  type PipelineEditorAttributes,
  type PipelineEditorGraphInput,
  type PipelineEditorGraphInputStep,
} from '../types.ts'
import { useGetBulkStepVersionQuery } from '../../../../../api/getBulkStepVersion.hooks.ts'

export const useGenerateGraphInput = (
  attributes: PipelineEditorAttributes
): [PipelineEditorGraphInput, boolean, (stepId: string, stepVersion: any) => void] => {
  const steps = attributes.steps
  const latestStepVersionMap = useGetBulkStepVersionQuery(steps)
  const pipelineStepIdToStepMap = useMemo(() => {
    const currentMap: {
      [pipelineStepId: string]: PipelineEditorGraphInputStep
    } = {}

    for (const step of steps) {
      if (!step.pipelineStepId) continue
      currentMap[step.pipelineStepId] = {
        step,
        stepVersion: latestStepVersionMap?.data?.[step?.stepId ?? -1],
      }
    }
    return currentMap
  }, [latestStepVersionMap?.data, steps])
  const graphInput: PipelineEditorGraphInput = useMemo(
    () => ({
      firstPipelineStepId: attributes.firstPipelineStepId,
      pipelineStepIdToStepMap,
    }),
    [attributes.firstPipelineStepId, pipelineStepIdToStepMap]
  )

  return [graphInput, latestStepVersionMap.isLoading, latestStepVersionMap.addToCache]
}
